import { SelfAssignmentEvent } from '../fr-event-modals/unit-self-assignment-modal';

export const getEventDataForSelfAssignmentModal = ({
    eventId,
    eventNumber,
    eventLocation,
    assignedUnits,
}: SelfAssignmentEvent) => {
    return {
        eventId,
        eventNumber,
        eventLocation,
        assignedUnits,
    };
};
